// src/hooks/useFormattedDateOnce.js
import { useMemo, useRef } from "react";

function format(d) {
  const pad = (n) => String(n).padStart(2, "0");
  const year = d.getFullYear();
  const month = pad(d.getMonth() + 1);
  const date = pad(d.getDate());
  const hours = pad(d.getHours());
  const minutes = pad(d.getMinutes());
  return {
    fullDate: `${year}-${month}-${date} ${hours}:${minutes}`,
    onlyDate: `${year}-${month}-${date}`,
    onlyTime: `${hours}:${minutes}`,
  };
}

/** 컴포넌트에서 훅을 호출한 ‘그 시점’의 날짜/시간을 고정해서 반환 */
export default function useFormattedDateOnce(at) {
  const ref = useRef(at ?? new Date());   // at을 주면 그 시각으로, 없으면 지금 시각
  return useMemo(() => ({ ...format(ref.current), date: ref.current }), []);
}
